import {
	IAnalyzeStatusDto,
	IRecalculationStatusDto,
	IReportDto,
	RecalculationStatus,
	ReportStatus,
	TaxAnalysisStatus,
} from './dtos'
import { IAnalyzeStatus, IRecalculationStatus, IReport } from './models'

export const mapReportFromDto = ({ reportName, url, status, progress }: IReportDto): IReport => ({
	status: status ? status : ReportStatus.EMPTY,
	url,
	name: reportName,
	progress,
})

export const mapAnalyzeStatusFromDto = ({ progress, status }: IAnalyzeStatusDto): IAnalyzeStatus => ({
	progress,
	status: status ? status : TaxAnalysisStatus.EMPTY,
})

export const mapRecalculationStatusFromDto = ({ progress, status }: IRecalculationStatusDto): IRecalculationStatus => ({
	progress,
	status: status ? status : RecalculationStatus.FINISHED,
})
